module.exports = __webpack_public_path__ + "img/no_order_pc.2729ca3.webp";